import { setDatePickers } from "./rmo/set-date-picker";
import { hideValidationMessage, showValidationMessage } from "../form-validation-message";
import getLanguage from "../get-language";
const mexicoComplaintForm = document.getElementById("mexico-form-complaint");

if (Boolean(mexicoComplaintForm)) {
  const formDateEl = mexicoComplaintForm.querySelector("#wu-input-form-date");
  const formDateIconEl = mexicoComplaintForm.querySelector("#dop-icon-el");
  const formSubmitBtn = mexicoComplaintForm.querySelector("#form-submit-btn");
  const formSubmitPopUpDivEl = document.querySelector("#submitMxFromConfirm");
  const formCancelPopUpDivEl = document.querySelector("#cancelMxFromConfirm");
  const formSubmitOkModalBtn = document.querySelector("#submit-ok-modal");
  const formCancelModalBtn = document.querySelector("#cancel-ok-modal");
  const formTransactionInfoTextAreaEl = document.querySelector("#text-area-transaction-info");
  const formCounterpartyInfoTextAreaEl = document.querySelector("#text-area-counterparty-info");
  const formUnusualDescpTextAreaEl = document.querySelector("#text-area-unusual-descp");
  const formAdditionalInfoTextAreaEl = document.querySelector("#text-area-additional-info");
  const formMtcnDivEl = document.querySelector("#input-mtcn");
  const formCharCountTxnInfo = document.querySelector("#char-count-trans-info");
  const formCharCountCounterPartyInfo = document.querySelector("#char-count-counter-info");
  const formCharCountUnusualDescp = document.querySelector("#char-count-unusual-info");
  const formCharCountAddInfo = document.querySelector("#char-count-add-info");
  const formHumanKeyEL = mexicoComplaintForm.querySelector("#humanKey");
  const formSpinner = document.getElementById('spinnerContainer');
  const formtechnicalError = mexicoComplaintForm.querySelector("#technical-error");
  const formBusinessError = mexicoComplaintForm.querySelector("#technical-error");
  let error = false;
  const { lang, country } = getLanguage();

  setDatePickers(formDateEl);

  document.addEventListener('captchaSuccessEvent' , () => {
    if(validateForm()) formSubmitBtn.removeAttribute('disabled')
      else formSubmitBtn.setAttribute('disabled', true)
  })

  function updateCharacterCount(textAreaEl, charCountEl) {
    textAreaEl.addEventListener("input", function () {
      charCountEl.textContent = textAreaEl.value.length;
    });
  }

  formDateIconEl.addEventListener('click', (e) => {
            e.preventDefault()
            e.target.closest('.wu-input--bordered').querySelector('input').focus()
        })
  
  formMtcnDivEl.addEventListener('input', (e) => e.target.setAttribute('value', e.target.value))

  formMtcnDivEl.onkeydown = (event) => {
    // Only allow if the e.key value is a number or if it's 'Backspace'
    if (isNaN(event.key) && event.key !== "Backspace") {
    event.preventDefault();
    }
  };

  function checkForAnyOneMandatoryField() {
    const fields = [
      formMtcnDivEl,
      formTransactionInfoTextAreaEl,
      formCounterpartyInfoTextAreaEl,
      formUnusualDescpTextAreaEl,
      formAdditionalInfoTextAreaEl
    ];
    return fields.some(field => field.value.trim() !== "");
   }

  function makeAllValuesEmptyAfterSubmit() {
    formDateEl.value = "";
    formMtcnDivEl.value = "";
    formTransactionInfoTextAreaEl.value = "";
    formCounterpartyInfoTextAreaEl.value = "";
    formUnusualDescpTextAreaEl.value = "";
    formAdditionalInfoTextAreaEl.value = "";
    formHumanKeyEL.value="";
    if(grecaptcha){
      grecaptcha.reset();
    }
  }

  function checkValidations(inputEl) {
    if (inputEl.value === "" || inputEl.value === undefined) {
      showValidationMessage(inputEl);
      error = true;
    } else {
      hideValidationMessage(inputEl);
      error = false;
    }
  }

  formDateEl.addEventListener("blur", (e) => {
    checkValidations(formDateEl)
  });
  formDateEl.addEventListener("input", (e) => {
    checkValidations(formDateEl)
  });

  function validateForm() {
    checkValidations(formDateEl)
    if (!error && formHumanKeyEL.value && checkForAnyOneMandatoryField()) {
      return true;
    }
    return false;
  }

  function onModalClickEvent (popUpButtonEL,modalDivEl){
    popUpButtonEL.addEventListener("click", (e) => {
      e.preventDefault();
      toggleClass(modalDivEl, "d-flex", "d-none");
      makeAllValuesEmptyAfterSubmit();
    });
  }

  const getToken = async (sessionID) => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "x-wu-externalRefId": `x-wu-externalRefId-`+ generateUniqueID(),
          "wucountrycode" :"US",
          "wulanguagecode": "en",
          "x-wu-sessionId": sessionID ? `x-wu-sessionId-${sessionID}`  : "x-wu-sessionId-49c48b440112",
          "x-wu-correlationId" : `x-wu-correlationId-`+ generateUniqueID(),
          "x-wu-operationname" : "v1Token",
          "Content-Type": "application/x-www-form-urlencoded",
          "x-api-key" :  isProdUrl() ? "2d068f4d-5c9e-40aa-90b4-d7fe6b329ce3" : "5b801930-857d-4231-9a41-f45ab9407863",
          "Accept-Language" : "en-US"
        }
      };
      const response = await fetchApiWu( `${location.origin}/auth/v1/token`, requestOptions, "getTokenForMexicoComplaintForm" );
      return response?.access_token;
    } catch (e) {
      // Error handled silently for security
    }
  };

  const triggerComplaintApi = async () => {
    showSpinnerMain(formSpinner)
    try {
      let complaintFormObject = {};
      const sessionResponse = await createSessionMethod(country, lang, location.host);
      const token = await getToken(sessionResponse?.security?.session?.id);
      complaintFormObject["captchaHumanKey"] = formHumanKeyEL.value;
      complaintFormObject["complaintDate"] = convertDateFormat(formDateEl.value);
      complaintFormObject["mtcn"] = formMtcnDivEl.value;
      complaintFormObject["txnInfo"] = formTransactionInfoTextAreaEl.value;
      complaintFormObject["counterPartyInfo"] = formCounterpartyInfoTextAreaEl.value;
      complaintFormObject["concernedTxnDetails"] = formUnusualDescpTextAreaEl.value;
      complaintFormObject["additionalComments"] = formAdditionalInfoTextAreaEl.value;

      const requestOptions = {
        method: "POST",
        headers: {
          "accept": "application/json",
          "x-wu-source" : "WU.COM",
          "Content-Type": "application/json",
          "Authorization": token?.startsWith('Bearer') ? token : `Bearer ${token}`,
          "x-wu-externalRefId": `x-wu-externalRefId-`+ generateUniqueID(),
          "Accept-Language" : lang
        },
        body: JSON.stringify(complaintFormObject),
      };
      const apiResponse = token ? await fetchApiWu(`${location.origin}/self-service/form/v1/complaint`, requestOptions, "mexico-complain-form") : null
      handleFormResponse(apiResponse)
    } catch (e) {
      hideSpinnerMain(formSpinner)
      // Error handled silently for security
    }
  };

  const handleFormResponse = (response) => {
    hideSpinnerMain(formSpinner)
    if(response?.icareCaseStatus == "Success"){ //on success
      onModalClickEvent(formSubmitOkModalBtn, formSubmitPopUpDivEl)
      toggleClass(formSubmitPopUpDivEl, "d-none", "d-flex");
    }
    else if(response?.errorResponse?.errorCode == "C1990"){ // business exception
      onModalClickEvent(formCancelModalBtn, formCancelPopUpDivEl)
      toggleClass(formBusinessError, "d-none", "d-flex");
      toggleClass(formCancelPopUpDivEl,  "d-none", "d-flex");
    }
    else{ // this is a fallback for every error including "C1989" tech exception
      onModalClickEvent(formCancelModalBtn, formCancelPopUpDivEl)
      toggleClass(formtechnicalError, "d-none", "d-flex");
      toggleClass(formCancelPopUpDivEl,  "d-none", "d-flex");
    }
 }

  updateCharacterCount(formTransactionInfoTextAreaEl, formCharCountTxnInfo);
  updateCharacterCount(formCounterpartyInfoTextAreaEl, formCharCountCounterPartyInfo);
  updateCharacterCount(formUnusualDescpTextAreaEl, formCharCountUnusualDescp);
  updateCharacterCount(formAdditionalInfoTextAreaEl, formCharCountAddInfo);

  mexicoComplaintForm.addEventListener("submit", (e) => {
    e.preventDefault();
    validateForm() && triggerComplaintApi();
  });
}
